import request from '@/util/request';
import qs from 'qs';

export const deviceTestPage = (params, options) =>
request.get('/api/v4ward/device/test/page', Object.assign({}, options, { params }));




  export const deviceTestSave = (params, options) =>
  request.post(
  '/api/v4ward/device/test/save',
  params,options
  );
 
export const getList = (params, options) =>
request.get('/api/v4ward/device/setting/warning/list', Object.assign({}, options, {params}));


export const getInitList = (params, options) =>
  request.get('/api/v4ward/device/setting/warning/init', Object.assign({}, options, {params}));



// 获取列表
export const getProjectList = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

export const updateRow = (params, options) =>
request.post('/api/v4ward/device/setting/warning/update', params, options);

// 字典
export const getDictionary = (params, options) =>
request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }))


// 字典
export const getProjectUserList = (params, options) =>
request.get('/api/v4ward/user/project-user-list', Object.assign({}, options, { params }))



export const getDeviceTestDetail = (params, options) =>
request.get('/api/v4ward/device/test/detail', Object.assign({}, options, { params }))

export const updateDeviceTestDetail = (params, options) =>
request.post('/api/v4ward/device/test/update', params, options)


export const getAttachDetail = (params, options) =>
request.get('/api/v4ward/attach/detail', Object.assign({}, options, { params }))

export const removeDeviceTestDetail = (params, options) =>
request.post('/api/v4ward/device/test/remove',  qs.stringify(params), options)